import { Dispatch } from "redux";
import { GetNotificationsFirstPagePerUser, GetNotificationsPerUser, markAllNotificationsAsRead, markNotificationAsRead } from "../../../api/General/Notification";

export const SET_NOTIFICATION_LIST = "notifications/SET_LIST";
export const SET_NOTIFICATION_TOTAL_COUNT = "notifications/SET_TOTAL_COUNT";
export const SET_NOTIFICATION_UNREAD_COUNT = "notifications/SET_UNREAD_COUNT";
export const INCREMENT_NOTIFICATIONS_UNREAD_COUNT = "notifications/INCREMENT_UNREAD_COUNT";

export const loadInitialNotifications = (userId: string) => {
    return async (dispatch: Dispatch) => {
        try {
            const result = await GetNotificationsFirstPagePerUser(userId);
            if (result.errors && result.errors.length > 0) return;
            const { payload } = result;
            dispatch({
                type: SET_NOTIFICATION_LIST,
                payload: payload.notificationsList
            });
            dispatch({
                type: SET_NOTIFICATION_TOTAL_COUNT,
                payload: payload.notificationsTotalCount
            });
            dispatch({
                type: SET_NOTIFICATION_UNREAD_COUNT,
                payload: payload.notificationsTotalUnreadCount
            });
        } catch (e) {
            console.error('Failed to load initial notifications', e);
        }
    };
};

export const loadNotifications = (userId: string, notificationType?: number, pageNumber?: number, pageSize?: number) => {
    return async (dispatch: Dispatch) => {
        try {
            const result = (typeof pageNumber !== "undefined" && pageSize)
                ? await GetNotificationsPerUser(userId, notificationType ?? 0, pageNumber ?? 1, pageSize ?? 15)
                : await GetNotificationsFirstPagePerUser(userId);
            if (result.errors && result.errors.length > 0) return;
            const { payload } = result;
            dispatch({
                type: SET_NOTIFICATION_LIST,
                payload: payload.notificationsList
            });
            dispatch({
                type: SET_NOTIFICATION_TOTAL_COUNT,
                payload: payload.notificationsTotalCount
            });
            dispatch({
                type: SET_NOTIFICATION_UNREAD_COUNT,
                payload: payload.notificationsTotalUnreadCount
            });
        } catch (e) {
            console.error('Failed to load notifications', e);
        }
    };
};

export const dismissAllNotifications = (userId: string) => {
    return async (dispatch: Dispatch, getState: () => any) => {
        try {
            const response = await markAllNotificationsAsRead(userId);
            if (response.payload) {
                const current = getState().notifications?.notifications || [];
                const updated = current.map((n: any) => ({ ...n, isRead: true }));
                dispatch({
                    type: SET_NOTIFICATION_UNREAD_COUNT,
                    payload: 0
                });
                dispatch({
                    type: SET_NOTIFICATION_LIST,
                    payload: updated
                });
            }
        } catch (e) {
            console.error('Failed to dismiss all notifications', e);
        }
    };
};

export const markNotificationAsReadAction = (id: number) => {
    return async (dispatch: Dispatch, getState: () => any) => {
        try {
            await markNotificationAsRead(id);
            const current = getState().notifications?.notifications || [];
            const updated = current.map((x: any) =>
                x.id === id ? { ...x, isRead: true } : x
            );
            dispatch({
                type: SET_NOTIFICATION_LIST,
                payload: updated
            });
        } catch (e) {
            console.error('Failed to mark notification as read', e);
        }
    };
};